'use client';
import { useEffect } from 'react';

/**
 * Loads a stylesheet after hydration so it can never block first paint. Use it for third-party
 * CSS that only affects small, non-critical text (text falls back to the next font in the stack
 * until the file arrives, then swaps).
 */
export default function DeferredStylesheet({ href }: { href: string }) {
  useEffect(() => {
    const selector = `link[data-deferred-stylesheet="${href}"]`;
    if (document.head.querySelector(selector)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.deferredStylesheet = href;
    document.head.appendChild(link);
  }, [href]);

  return null;
}
